import RegistrierenPage from "@/pages/RegistrierenPage";
import WhatsAppBestaetigenPage from "@/pages/WhatsAppBestaetigenPage";
import LegalPage from "@/pages/LegalPage";
import GrafikStudioPage from "@/pages/GrafikStudioPage";
import MiniWebsitePage from "@/pages/MiniWebsitePage";
import VideostudioPage from "@/pages/VideostudioPage";
import LandingHandelGastroPage from "@/pages/LandingHandelGastroPage";
import LandingVereineTicketsPage from "@/pages/LandingVereineTicketsPage";
import { useEffect, useState, lazy, Suspense } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation, useParams } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

export const LAZY_PAGES = [];
const lazyPage = (f) => { const c = lazy(f); LAZY_PAGES.push(c); return c; };
// Statt weißer Fläche beim Nachladen von /app, /portal, /kunden … (Live-Befund 09.10.: „/app lud zuerst weiß“): kleiner, sofort sichtbarer Ladehinweis.
export const LadeHinweis = () => {
  const p = typeof window === "undefined" ? "/" : window.location.pathname;
  const app = /^\/(app|portal|kunden|admin|einlass)(\/|$)/.test(p);
  return (
    <div className={`flex flex-col items-center justify-center gap-3 ${app ? "min-h-screen bg-[#F6F6F2]" : "min-h-[60vh]"}`} aria-busy="true" role="status" data-testid="lade-hinweis">
      {app && <>
        <img src="/img/mascots/robbie-winkt.webp" alt="Robbie winkt" width="112" height="112" className="h-40 w-40 sm:h-56 sm:w-56 object-contain animate-[robbie-winken_1.6s_ease-in-out_infinite] origin-bottom" data-testid="lade-robbie" />
        <span className="h-1.5 w-32 overflow-hidden rounded-full bg-[#E5E0D4]"><span className="block h-full w-1/2 animate-pulse rounded-full bg-[#111]" /></span>
        <span className="text-base sm:text-lg font-semibold text-[#111]">{p.startsWith("/portal") ? "Hallo! Dein Portal kommt gleich …" : "Hallo! Robbie kommt gleich …"}</span>
      </>}
    </div>
  );
};
export const preloadPages = () => Promise.all(LAZY_PAGES.map((c) => { try { c._init(c._payload); } catch (p) { return p && p.then ? p.catch(() => null) : null; } return null; }));
import Nav from "@/components/Nav";
import { BlackWeeksBanner } from "@/components/BlackWeeksBanner";
import { TicketBanner } from "@/components/TicketBanner";
import WalletAddPage from "@/pages/WalletAddPage";
import Footer from "@/components/Footer";
import CookieNotice from "@/components/CookieNotice";
import { BesuchZaehler } from "@/components/BesuchZaehler";
import { FrameGuard } from "@/components/tickets/Embed";
import { ShareButton } from "@/components/ShareButton";
import { AuthProvider, ProtectedRoute } from "@/portal/AuthContext";
import { HelpProvider, HelpLauncher } from "@/components/help/HelpCenter";
import { CloudDialogHost } from "@/portal/CloudDialogs";
import { RobbieWebHinweis } from "@/components/RobbieWebHinweis";
import { RouteErrorBoundary } from "@/components/RouteErrorBoundary";
import { isMinibioHost } from "@/lib/minibio";
import MinibioApp from "@/MinibioApp";
const PasswortFestlegen = lazyPage(() => import("@/pages/PasswortPage").then((m) => ({ default: m.PasswortFestlegen })));
const PasswortVergessen = lazyPage(() => import("@/pages/PasswortPage").then((m) => ({ default: m.PasswortVergessen })));
const StandortEinladung = lazyPage(() => import("@/pages/PasswortPage").then((m) => ({ default: m.StandortEinladung })));
const KundenLogin = lazyPage(() => import("@/pages/KundenLogin"));
const PortalPage = lazyPage(() => import("@/pages/PortalPage"));
const AbnahmePage = lazyPage(() => import("@/pages/AbnahmePage"));
const LiveDemoPage = lazyPage(() => import("@/pages/LiveDemoPage"));
const StudioPage = lazyPage(() => import("@/pages/StudioPage"));
const BaukastenEditor = lazyPage(() => import("@/pages/BaukastenEditor"));
const StudioEditorPage = lazyPage(() => import("@/pages/StudioEditorPage"));
const StudioGuthabenPage = lazyPage(() => import("@/pages/StudioGuthabenPage"));
const StudioBrandingPage = lazyPage(() => import("@/pages/StudioBrandingPage"));
const UeberUnsPage = lazyPage(() => import("@/pages/UeberUnsPage"));
const ReferenzenPage = lazyPage(() => import("@/pages/ReferenzenPage"));
const GastroOwlPage = lazyPage(() => import("@/pages/GastroOwlPage"));
const SichtbarkeitPage = lazyPage(() => import("@/pages/SichtbarkeitPage"));
const EinzelhandelOwlPage = lazyPage(() => import("@/pages/EinzelhandelOwlPage"));
const VereineTicketingOwlPage = lazyPage(() => import("@/pages/VereineTicketingOwlPage"));

const PaymentResultPage = lazyPage(() => import("@/pages/PaymentResultPage"));
const SocialWelcomePage = lazyPage(() => import("@/pages/SocialWelcomePage"));
const WordPressPluginPage = lazyPage(() => import("@/pages/WordPressPluginPage"));
const FilialverwaltungPage = lazyPage(() => import("@/pages/FilialverwaltungPage"));
const WelcomePage = lazyPage(() => import("@/pages/WelcomePage"));
const RobbieGuidePage = lazyPage(() => import("@/pages/RobbieGuidePage"));
const RobbieCheatSheetPage = lazyPage(() => import("@/pages/RobbieCheatSheetPage"));
const AdminPage = lazyPage(() => import("@/pages/AdminPage"));
import Home from "@/pages/Home";
import DigitalWeiterleitung from "@/pages/DigitalWeiterleitung";
import AltWeiterleitung from "@/components/AltWeiterleitung";
import AutopilotPage from "@/pages/AutopilotPage";
import PreisePage from "@/pages/PreisePage";
import ServicePage from "@/pages/ServicePage";
import KontaktPage from "@/pages/KontaktPage";
import StickerPage from "@/pages/StickerPage";
import NewzerPage from "@/pages/NewzerPage";
const PressePage = lazyPage(() => import("@/pages/PressePage"));
const PressReleasePage = lazyPage(() => import("@/pages/PressReleasePage"));
import Impressum from "@/pages/Impressum";
import SocialTerms from "@/pages/SocialTerms";
import RobbiePage from "@/pages/RobbiePage";
import DemoWebsitePage from "@/pages/DemoWebsitePage";
import GameChangerPage from "@/pages/GameChangerPage";
import Datenschutz from "@/pages/Datenschutz";
import Datenloeschung from "@/pages/Datenloeschung";
const HostingPage = lazyPage(() => import("@/pages/HostingPage"));
const HilfePage = lazyPage(() => import("@/pages/HilfePage"));
const SignagePage = lazyPage(() => import("@/pages/SignagePage"));
const TicketsPage = lazyPage(() => import("@/pages/TicketsPage"));
const EinlassPage = lazyPage(() => import("@/pages/EinlassPage"));
const ScanZugangPage = lazyPage(() => import("@/pages/ScanZugangPage"));
const TicketEventPage = lazyPage(() => import("@/pages/TicketEventPage"));
const EinladungPage = lazyPage(() => import("@/pages/EinladungPage"));
const ListePage = lazyPage(() => import("@/pages/ListePage"));
const ListenHubPage = lazyPage(() => import("@/pages/ListenHubPage"));
const AppPage = lazyPage(() => import("@/pages/AppPage"));
const SaisonPage = lazyPage(() => import("@/pages/SaisonPage"));
const KartePage = lazyPage(() => import("@/pages/KartePage"));
const MedienVorschauPage = lazyPage(() => import("@/pages/MedienVorschauPage"));
const TicketVeranstalterPage = lazyPage(() => import("@/pages/TicketVeranstalterPage"));
const TicketsDemoPage = lazyPage(() => import("@/pages/TicketsDemoPage"));
const SignagePlayer = lazyPage(() => import("@/portal/signage/Player"));
const PassPage = lazyPage(() => import("@/pages/PassPage"));
const PassScannerPage = lazyPage(() => import("@/pages/PassScannerPage"));
const ReelPreviewPage = lazyPage(() => import("@/pages/ReelPreviewPage"));
const KundenkartePage = lazyPage(() => import("@/pages/KundenkartePage"));
const KundenUebersicht = lazyPage(() => import("@/pages/KundenUebersicht"));
const SignageSharePlayer = lazyPage(() => import("@/portal/signage/SharePlayer"));
const CloudPage = lazyPage(() => import("@/pages/CloudPage"));
const CloudFreePage = lazyPage(() => import("@/pages/CloudFreePage"));
const PartnerPage = lazyPage(() => import("@/pages/PartnerPage"));
const CloudFreeDownloadPage = lazyPage(() => import("@/pages/CloudFreeDownloadPage"));
const FallbeispielPage = lazyPage(() => import("@/pages/FallbeispielPage"));
const NotFoundPage = lazyPage(() => import("@/pages/NotFoundPage"));
const BioStudioPage = lazyPage(() => import("@/pages/BioStudioPage"));
const BioHandleDispatch = lazyPage(() => import("@/pages/BioHandleDispatch"));
const BrainPage = lazyPage(() => import("@/pages/BrainPage"));
const SocialPage = lazyPage(() => import("@/pages/SocialPage"));
const TikTokLandingPage = lazyPage(() => import("@/pages/TikTokLandingPage"));
const TikTokCheckPage = lazyPage(() => import("@/pages/TikTokCheckPage"));
const GratisPage = lazyPage(() => import("@/pages/GratisPage"));
const SchnittstellePage = lazyPage(() => import("@/pages/SchnittstellePage"));
const MarkengesichtPage = lazyPage(() => import("@/pages/MarkengesichtPage"));
const ConnectPage = lazyPage(() => import("@/pages/ConnectPage"));
const UploadLinkPage = lazyPage(() => import("@/pages/UploadLinkPage"));
const SharePage = lazyPage(() => import("@/pages/SharePage"));
// /s/:token wird von zwei Features genutzt: Cloud-Freigaben (SharePage, Backend /api/s/<token>) und Saisonkarten (SaisonPage).
// Dispatcher prüft die Cloud-Freigabe: 404 => Saisonkarten-Slug, sonst (200/410/403/Fehler) => Cloud-Freigabe. So bleiben beide bestehenden Linkformate gültig.
const SlugDispatch = () => {
  const { token } = useParams();
  const [kind, setKind] = useState(null);
  useEffect(() => {
    let alive = true;
    setKind(null);
    window.dispatchEvent(new CustomEvent("dm-slug-kind", { detail: null }));
    const emit = (k) => { if (!alive) return; setKind(k); window.dispatchEvent(new CustomEvent("dm-slug-kind", { detail: k })); };
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/s/${token}`, { headers: { Accept: "application/json", "Cache-Control": "no-cache" } })
      .then((r) => emit(r.status === 404 ? "saison" : "share"))
      .catch(() => emit("share"));
    return () => { alive = false; };
  }, [token]);
  if (kind === null) return <LadeHinweis />;
  return kind === "share" ? <SharePage /> : <SaisonPage slug={token} />;
};
// Kundenkarte-Kurzlink /k/<slug> → Backend /api/k/<slug> (liefert OG-Tags + Weiterleitung zur Karte).
const KurzlinkRedirect = () => {
  const { slug } = useParams();
  useEffect(() => { window.location.replace(`${process.env.REACT_APP_BACKEND_URL}/api/k/${slug}`); }, [slug]);
  return <LadeHinweis />;
};
const SepaResultPage = lazyPage(() => import("@/pages/SepaResultPage"));
const HomepageDesignPreview = lazyPage(() => import("@/pages/HomepageDesignPreview"));
const HomepagePage = lazyPage(() => import("@/pages/HomepagePage"));
const SharedPreview = lazyPage(() => import("@/pages/SharedPreview"));
const MasterVorschauGeteilt = lazyPage(() => import("@/pages/MasterVorschauGeteilt"));
const CampaignPreview = lazyPage(() => import("@/pages/CampaignPreview"));
const GooglePage = lazyPage(() => import("@/pages/GooglePage"));

/* „Beitrag ansehen“-Links (WhatsApp/Mail): Beitrag merken, Kalender in der App öffnet und markiert genau ihn. */
const BeitragRedirect = () => {
  const { pid } = useParams();
  if (pid) sessionStorage.setItem("beitrag_fokus", pid);
  return <Navigate to="/app/social#social/kalender" replace />;
};

const ClientToaster = () => {
  const [Toaster, setToaster] = useState(null);
  useEffect(() => {
    import("@/components/ui/sonner").then((m) => setToaster(() => m.Toaster));
  }, []);
  return Toaster ? <Toaster position="bottom-center" toastOptions={{ style: { background: "#1A1A1A", border: "1px solid rgba(245,245,240,0.12)", color: "#F5F5F0" } }} /> : null;
};

const ScrollManager = () => {
  const location = useLocation();

  useEffect(() => {
    const ref = new window.URLSearchParams(location.search).get("ref");
    if (ref && /^[A-Z0-9]{6}$/i.test(ref)) { try { localStorage.setItem("dimedial-ref", ref.toUpperCase()); } catch { /* ignore */ } }
  }, [location.search]);

  useEffect(() => {
    const lenis = window.__lenis;
    let target = null;
    if (location.hash && /^#[A-Za-z][\w-]*$/.test(location.hash)) target = document.getElementById(location.hash.slice(1));
    const timer = setTimeout(() => {
      if (target) {
        if (lenis) lenis.scrollTo(target, { offset: -72, duration: 1.4 });
        else target.scrollIntoView({ behavior: "smooth" });
      } else {
        if (lenis) lenis.scrollTo(0, { immediate: true });
        else window.scrollTo(0, 0);
      }
    }, 60);
    return () => clearTimeout(timer);
  }, [location.pathname, location.hash]);

  return null;
};

const ShareButtonGuard = () => (/^\/(t|v|s|karte)\//.test(useLocation().pathname) ? null : <ShareButton />);

// Lenis NUR auf Marketing-Seiten; im gesamten eingeloggten Bereich (Portal, Admin, Kundenbereich, App, Paket-Buchung unter /portal, alle Editoren) aus.
// Wortgrenze (\/|$) verhindert, dass z. B. /kundenkarte (Marketing) fälschlich als /kunden gilt.
const APP_ROUTES = /^\/(portal|admin|kunden|app|upload|passwort|zahlung|baukasten|studio-editor|studio-guthaben|link-in-bio)(\/|$)/;

const LenisRoot = ({ children }) => {
  const { pathname } = useLocation();
  const enabled = !APP_ROUTES.test(pathname);
  useEffect(() => {
    if (!enabled || window.matchMedia("(prefers-reduced-motion: reduce)").matches || !window.matchMedia("(pointer: fine)").matches) {
      window.__lenis = null;
      return undefined;
    }
    let lenis = null;
    let rafId = null;
    let cancelled = false;
    import("lenis").then(({ default: Lenis }) => {
      if (cancelled) return;
      lenis = new Lenis({ duration: 1.15, smoothWheel: true });
      window.__lenis = lenis;
      const raf = (time) => {
        lenis.raf(time);
        rafId = requestAnimationFrame(raf);
      };
      rafId = requestAnimationFrame(raf);
    });
    return () => {
      cancelled = true;
      if (rafId) cancelAnimationFrame(rafId);
      if (lenis) lenis.destroy();
      window.__lenis = null;
    };
  }, [enabled]);
  return children;
};

function App({ RouterComponent, routerProps = {}, helmetContext }) {
  const Router = RouterComponent || BrowserRouter;
  if (isMinibioHost()) {
    return (
      <HelmetProvider context={helmetContext}>
        <div className="App grain bg-ink text-paper min-h-screen">
          <Router {...routerProps}><MinibioApp /></Router>
        </div>
      </HelmetProvider>
    );
  }
  return (
    <HelmetProvider context={helmetContext}>
      <div className="App grain bg-ink text-paper min-h-screen">
        <Router {...routerProps}>
          <AuthProvider>
            <HelpProvider>
            <LenisRoot>
              <ScrollManager />
              <FrameGuard />
              <BlackWeeksBanner />
              <TicketBanner />
              <Nav />
              <main>
                <Suspense fallback={<LadeHinweis />}>
                <RouteErrorBoundary>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/hilfe" element={<HilfePage />} />
                  <Route path="/hilfe/:slug" element={<HilfePage />} />
                  <Route path="/aktuell/:storyId" element={<Home />} />
                  <Route path="/video" element={<ServicePage service="video" />} />
                  <Route path="/audio" element={<ServicePage service="audio" />} />
                  <Route path="/agentur" element={<ServicePage service="agentur" />} />
                  <Route path="/newzer" element={<NewzerPage />} />
                  <Route path="/presse" element={<PressePage />} />
                  <Route path="/presse/:slug" element={<PressReleasePage />} />
                  <Route path="/newzer/presse" element={<Navigate to="/presse/dimedial-startet-newzer" replace />} />
                  <Route path="/filmproduktion-herford" element={<ServicePage service="filmproduktion" />} />
                  <Route path="/webdesign-herford" element={<ServicePage service="webdesign" />} />
                  <Route path="/social-media-gastronomie-owl" element={<GastroOwlPage />} />
                  <Route path="/sichtbarkeit" element={<SichtbarkeitPage />} />
                  <Route path="/social-media-einzelhandel-owl" element={<EinzelhandelOwlPage />} />
                  <Route path="/ticketing-sportvereine-owl" element={<VereineTicketingOwlPage />} />
                  <Route path="/aktion/handel-gastro" element={<LandingHandelGastroPage />} />
                  <Route path="/aktion/vereine" element={<LandingVereineTicketsPage />} />
                  <Route path="/hosting" element={<HostingPage />} />
                  <Route path="/tiktok" element={<TikTokLandingPage />} />
                  <Route path="/tiktok-check" element={<TikTokCheckPage />} />
                  <Route path="/gratis" element={<GratisPage />} />
                  <Route path="/digital-signage" element={<SignagePage />} />
                  <Route path="/grafik-studio" element={<GrafikStudioPage />} />
                  <Route path="/robbies-kaffeekueche" element={<DemoWebsitePage />} />
                  <Route path="/mini-website" element={<MiniWebsitePage />} />
                 <Route path="/videostudio" element={<VideostudioPage />} />
                  <Route path="/kundenkarte" element={<KundenkartePage />} />
                  <Route path="/tickets" element={<TicketsPage />} />
                  <Route path="/tickets/demo" element={<TicketsDemoPage />} />
                  <Route path="/t/:slug" element={<TicketEventPage />} />
                  <Route path="/einladung/:token" element={<EinladungPage />} />
                  <Route path="/app" element={<AppPage />} />
                  <Route path="/app/*" element={<AppPage />} />
                  <Route path="/l" element={<ListenHubPage />} />
                  <Route path="/l/:lid" element={<ListePage />} />
                  <Route path="/s/:token" element={<SlugDispatch />} />
                  <Route path="/k/:slug" element={<KurzlinkRedirect />} />
                  <Route path="/karte/:oid/:tid" element={<KartePage />} />
                  <Route path="/vorschau/:aid/:token" element={<MedienVorschauPage />} />
                  <Route path="/v/:slug" element={<TicketVeranstalterPage />} />
                  <Route path="/einlass" element={<EinlassPage />} />
                  <Route path="/scan/:token" element={<ScanZugangPage />} />
                  <Route path="/player" element={<SignagePlayer />} />
                  <Route path="/pass" element={<PassPage />} />
                  <Route path="/wallet/hinzufuegen" element={<WalletAddPage />} />
                  <Route path="/pass-scanner" element={<PassScannerPage />} />
                  <Route path="/stele/f/:token" element={<SignageSharePlayer />} />
                  <Route path="/cloud" element={<CloudPage />} />
                  <Route path="/cloud-free" element={<CloudFreePage />} />
                  <Route path="/partner" element={<PartnerPage />} />
                  <Route path="/cf/:token" element={<CloudFreeDownloadPage />} />
                  <Route path="/fallbeispiele" element={<Navigate to="/fallbeispiele/sportvereine" replace />} />
                  <Route path="/fallbeispiele/:branche" element={<FallbeispielPage />} />
                  <Route path="/404" element={<NotFoundPage />} />
                  <Route path="/abnahme" element={<AbnahmePage />} />
                  <Route path="/live-demo" element={<LiveDemoPage />} />
                  <Route path="/dein-buero" element={<BrainPage />} />
                  <Route path="/brain" element={<Navigate to="/dein-buero" replace />} />
                  <Route path="/upload/:token" element={<UploadLinkPage />} />
                  <Route path="/social" element={<SocialPage />} />
                  <Route path="/autopilot" element={<AutopilotPage />} />
                  <Route path="/preise" element={<PreisePage />} />
                  <Route path="/homepage" element={<HomepagePage />} />
                  <Route path="/homepage/design-vorschau" element={<HomepageDesignPreview />} />
                  <Route path="/homepage/vorschau/:st" element={<SharedPreview />} />
                  <Route path="/masterlayout/vorschau/:token" element={<MasterVorschauGeteilt />} />
                  <Route path="/preview/kampagne" element={<CampaignPreview />} />
                  <Route path="/google" element={<GooglePage />} />
                  <Route path="/impressum" element={<Impressum />} />
                  <Route path="/social/bedingungen" element={<SocialTerms />} />
                  <Route path="/social/willkommen" element={<SocialWelcomePage />} />
                  <Route path="/social/wordpress" element={<WordPressPluginPage />} />
                  <Route path="/social/filialverwaltung" element={<FilialverwaltungPage />} />
                  <Route path="/social/schnittstelle" element={<SchnittstellePage />} />
                  <Route path="/social/markengesicht" element={<MarkengesichtPage />} />
                  <Route path="/robbie" element={<RobbiePage />} />
                  <Route path="/gamechanger" element={<GameChangerPage />} />
                  <Route path="/willkommen" element={<WelcomePage />} />
                  <Route path="/robbie/anleitung" element={<RobbieGuidePage />} />
                  <Route path="/robbie/spickzettel" element={<RobbieCheatSheetPage />} />
                  <Route path="/datenschutz" element={<Datenschutz />} />
                  <Route path="/datenloeschung" element={<Datenloeschung />} />
                  <Route path="/kunden" element={<KundenLogin />} />
                  <Route path="/kunden/connect" element={<ConnectPage />} />
                  <Route path="/kunden/passwort" element={<PasswortFestlegen />} />
                  <Route path="/kunden/passwort-vergessen" element={<PasswortVergessen />} />
                  <Route path="/kunden/standort-einladung" element={<StandortEinladung />} />
                  <Route path="/kunden/registrieren" element={<RegistrierenPage />} />
                  <Route path="/kunden/whatsapp-bestaetigen" element={<WhatsAppBestaetigenPage />} />
                  <Route path="/agb" element={<LegalPage docKey="agb" />} />
                  <Route path="/widerruf" element={<LegalPage docKey="widerrufsbelehrung" />} />
                  <Route path="/widerrufsformular" element={<LegalPage docKey="widerrufsformular" />} />
                  <Route path="/portal" element={<ProtectedRoute><PortalPage /></ProtectedRoute>} />
                  <Route path="/portal/studio" element={<ProtectedRoute><StudioPage /></ProtectedRoute>} />
                  <Route path="/portal/beitrag/:pid" element={<BeitragRedirect />} />
                  <Route path="/app/beitrag/:pid" element={<BeitragRedirect />} />
                  <Route path="/admin/meldung/:mid" element={<Navigate to="/admin?tab=social" replace />} />
                  <Route path="/baukasten/:did" element={<ProtectedRoute><BaukastenEditor /></ProtectedRoute>} />
                  <Route path="/studio-editor/:projectId" element={<ProtectedRoute><StudioEditorPage /></ProtectedRoute>} />
                  <Route path="/studio-guthaben" element={<ProtectedRoute><StudioGuthabenPage /></ProtectedRoute>} />
                  <Route path="/studio-branding" element={<ProtectedRoute><StudioBrandingPage /></ProtectedRoute>} />
                  <Route path="/mein-tag" element={<Navigate to="/app" replace />} />
                  <Route path="/mein-brain" element={<Navigate to="/app/buero" replace />} />
                  <Route path="/payment/success" element={<PaymentResultPage />} />
                  <Route path="/payment/cancel" element={<PaymentResultPage cancelled />} />
                  <Route path="/zahlung/sepa" element={<SepaResultPage />} />
                  <Route path="/admin" element={<ProtectedRoute role="admin"><AdminPage /></ProtectedRoute>} />
                  <Route path="/admin/kunde/:cid/uebersicht" element={<ProtectedRoute role="admin"><KundenUebersicht /></ProtectedRoute>} />
                  <Route path="/kontakt" element={<KontaktPage />} />
                  <Route path="/ueber-uns" element={<UeberUnsPage />} />
                  <Route path="/sticker" element={<StickerPage />} />
                  <Route path="/referenzen" element={<ReferenzenPage />} />
                  <Route path="/filmproduktion" element={<Navigate to="/filmproduktion-herford" replace />} />
                  <Route path="/videoproduktion" element={<Navigate to="/video" replace />} />
                  <Route path="/tonstudio" element={<Navigate to="/audio" replace />} />
                  <Route path="/audioproduktion" element={<Navigate to="/audio" replace />} />
                  <Route path="/webdesign" element={<Navigate to="/agentur" replace />} />
                  <Route path="/digital" element={<DigitalWeiterleitung />} />
                  <Route path="/contact" element={<AltWeiterleitung ziel="/kontakt" titel="Kontakt" />} />
                  <Route path="/jimmy-co" element={<AltWeiterleitung ziel="/referenzen" titel="Referenzen" />} />
                  <Route path="/neuer-snack-im-capitol-kino-herford" element={<AltWeiterleitung ziel="/fallbeispiele/gastronomie" titel="Beispiele Gastronomie" />} />
                  <Route path="/dimedial-vertont-den-eurovision-song-contest" element={<AltWeiterleitung ziel="/audio" titel="Audioproduktion" />} />
                  <Route path="/studio/thomas_dickenbrok" element={<AltWeiterleitung ziel="/ueber-uns" titel="Über uns" />} />
                  <Route path="/newsletter" element={<Navigate to="/fallbeispiele/newsletter" replace />} />
                  <Route path="/link-in-bio" element={<ProtectedRoute><BioStudioPage /></ProtectedRoute>} />
                  <Route path="/reel/:token" element={<ReelPreviewPage />} />
                  <Route path="/:handle" element={<BioHandleDispatch />} />
                  <Route path="*" element={<NotFoundPage />} />
                </Routes>
                </RouteErrorBoundary>
                </Suspense>
              </main>
              <Footer />
              <ShareButtonGuard />
              <CookieNotice />
              <BesuchZaehler />
              <ClientToaster />
              <CloudDialogHost />
              <RobbieWebHinweis />
              <HelpLauncher />
            </LenisRoot>
            </HelpProvider>
          </AuthProvider>
        </Router>
      </div>
    </HelmetProvider>
  );
}

export default App;
